import { AlignmentType, HeadingLevel, Paragraph, TabStopType, TextRun, WidthType } from "docx";


export const Conclusion = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 150, after: 100, },

    children: [
        new TextRun({
            text: "10. Conclusion",
            size: 26,
            color: "C00000",
            font: "Cambria",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_2,
})

export function conclusionText1(certInApplicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 600 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION Security Auditors conducted Source Code Security Audit on the given ${certInApplicationName}`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const conclusionText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 5000, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Audit Conducted By: ",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 200, after: 100 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Kapil Bardewa",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export const conclusionText4 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 100, after: 600 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Aghilesh B",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export const conclusionText5 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 650, after: 150 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Report Prepared By:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText6 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 600 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Kapil Bardewa",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export const conclusionText7 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 750, after: 150 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Report Reviewed By:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText8 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 100 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Mr. Manjunath NG (Director)",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText9 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 80 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "ISECURION Technology & Consulting Pvt. Ltd",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export const conclusionText10 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 80, after: 80 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Bangalore",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})


export function conclusionText11(dateString) {
    const date = new Date(dateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const formattedDate = `${date.getDate()}`;
    const ordinalSuffix = getOrdinalSuffix(date.getDate());
    const formatMonth = monthNames[date.getMonth()];
    const formatYear = date.getFullYear();

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 400 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: formattedDate,
                font: "Calibri",
                size: 22,
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ordinalSuffix,
                superScript: true,
                font: "Calibri",
                size: 22,
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formatMonth + ' ' + formatYear,
                font: "Calibri",
                size: 22,
                color: '000000',
                italics: false
            })
        ],
    })
}